import { CSSProperties, FC } from 'react';

import ColumnarListSkeleton from '@/shared/components/lists/ColumnarListSkeleton';

export const SEARCH_RESULTS_SKELETON_ROWS = 18;
export const SEARCH_RESULTS_SECTION_SKELETON_ROWS = 8;

export type SearchSkeletonDomain =
    | 'companies'
    | 'documents'
    | 'economic'
    | 'events'
    | 'news'
    | 'people'
    | 'trade'
    | 'workspace';

interface SearchResultsSkeletonProps {
    columnCount?: number;
    domain?: SearchSkeletonDomain;
    includeHeader?: boolean;
    rows?: number;
    style?: CSSProperties;
}

const DOMAIN_COLUMN_COUNTS: Record<SearchSkeletonDomain, number> = {
    companies: 4,
    documents: 3,
    economic: 3,
    events: 3,
    news: 3,
    people: 3,
    trade: 3,
    workspace: 3,
};

const SearchResultsSkeleton: FC<SearchResultsSkeletonProps> = ({
    columnCount,
    domain = 'companies',
    includeHeader = true,
    rows = SEARCH_RESULTS_SKELETON_ROWS,
    style,
}) => (
    <ColumnarListSkeleton
        ariaLabel={`Loading ${domain} search results`}
        avatarShape={domain === 'people' ? 'circle' : 'square'}
        columnCount={columnCount ?? DOMAIN_COLUMN_COUNTS[domain]}
        includeHeader={includeHeader}
        rowDataAttribute='data-search-results-skeleton-row'
        rows={rows}
        style={style}
    />
);

export default SearchResultsSkeleton;
